import { useEffect, useState } from 'react';

/** The value, once it has stopped changing for `ms` milliseconds. For search-as-you-type. */
export function useDebounced(value: string, ms: number): string {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const handle = setTimeout(() => {
      setDebounced(value);
    }, ms);
    return () => {
      clearTimeout(handle);
    };
  }, [value, ms]);
  return debounced;
}
